import React, { useEffect, useMemo, useState } from "react";
import "./SalaryConfig.css";
import { GrAddCircle } from "react-icons/gr";
import { CiEdit } from "react-icons/ci";
import { RiDeleteBinLine } from "react-icons/ri";
import { IoMdCheckmark, IoMdClose } from "react-icons/io";
import config from "../../../config";
import SuccessPopup from "../../../components/common/SuccessPopup";
import ErrorPopup from "../../../components/common/ErrorPopup";
import ConfirmPopup from "../../../components/common/ConfirmPopup";

const formatCurrency = (n) =>
  n?.toLocaleString("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }) ?? "-";

const SalaryConfig = ({ userDetails }) => {
  const [clients, setClients] = useState([]);
  const [jobRoles, setJobRoles] = useState([]);
  const [bands, setBands] = useState([]);
const [selectedClientId, setSelectedClientId] = useState("");

const [selectedJobRole, setSelectedJobRole] = useState("");
const [selectedJobRoleName, setSelectedJobRoleName] = useState("");
const [selectedClientName, setSelectedClientName] = useState("");
const [selectedBand, setSelectedBand] = useState("");
const [clientPayment, setClientPayment] = useState("");
const [serviceCharge, setServiceCharge] = useState("");
const [componentsList, setComponentsList] = useState([
  {
    componentName: "Basic Salary",
    componentType: "EARNING",
    calculationType: "FIXED",
    componentValue: "",
    valuePeriod: "MONTH",
    holidayCalendar: "INDIA",
  },
  {
    componentName: "PF",
    componentType: "DEDUCTION",
    calculationType: "PERCENTAGE",
    componentValue: "",
    valuePeriod: "MONTH",
    holidayCalendar: "INDIA",
  },
  {
    componentName: "ESI",
    componentType: "DEDUCTION",
    calculationType: "PERCENTAGE",
    componentValue: "",
    valuePeriod: "MONTH",
    holidayCalendar: "INDIA",
  },
]);

const updateComponent = (index, key, value) => {
  const updated = [...componentsList];
  updated[index][key] = value;
  setComponentsList(updated);
};




  const [filters, setFilters] = useState({ client: "", jobRole: "", band: "" });
  const [rows, setRows] = useState([]);
  const [adding, setAdding] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [editingRowId, setEditingRowId] = useState(null);
  const [showComponentCard, setShowComponentCard] = useState(false);

  // popup state
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [confirmState, setConfirmState] = useState({ show: false, message: "", onConfirm: null });

  const showConfirm = (message, onConfirm) => setConfirmState({ show: true, message, onConfirm });
  const hideConfirm = () => setConfirmState({ show: false, message: "", onConfirm: null });

  

 const handleUpdateSalaryConfig = async () => {
  try {
    // 1. Validation Check
    if (!selectedClientId || !selectedJobRole || !selectedBand) {
      setErrorMsg("Please fill Client, Job Role, and Band.");
      return;
    }

    const payload = {
      orgKey: Number(userDetails.orgId),
      clientKey: Number(selectedClientId),
      clientName: selectedClientName,
      roleId: Number(selectedJobRole),
      jobRole: selectedJobRoleName,
      band: Number(selectedBand),
      clientPayment: Number(clientPayment),
      deduction: componentsList
        .filter((c) => c.componentType === "DEDUCTION")
        .reduce((sum, c) => sum + Number(c.componentValue || 0), 0),
      serviceCharges: Number(serviceCharge),
      components: componentsList.map((c) => ({
        componentName: c.componentName,
        componentType: c.componentType,
        calculationType: c.calculationType,
        componentValue: Number(c.componentValue),
        valuePeriod: c.valuePeriod,
        holidayCalendar: c.holidayCalendar,
      })),
    };

    console.log("Updating ID:", editingRowId);
    console.log("Payload:", payload);

    // 2. Check if Endpoint exists
   const endpoint = config.SALARY_CONFIG_EDIT_ENDPOINT; 
    if (!endpoint) {
       throw new Error("API Endpoint 'SALARY_CONFIG_EDIT_ENDPOINT' is missing in config.js");
    }

   const res = await fetch(
      `${config.API_BASE_URL}${endpoint}/${editingRowId}`, // Now 'endpoint' exists
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDetails.token}`,
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      throw new Error(data.message || `Server responded with ${res.status}`);
    }

    setSuccessMsg(data.message || "Salary configuration updated successfully!");
    closeModal();
    fetchSalaryConfigs();
  } catch (err) {
    console.error("Full Error Details:", err);
    setErrorMsg(`Update failed: ${err.message}`);
  }
};
const fetchClients = async () => {
  try {
    const orgId = userDetails?.orgId || "6";
    const res = await fetch(
      `${config.API_BASE_URL}${config.CLIENT_LIST_ENDPOINT}${orgId}`,
      {
        headers: { Authorization: `Bearer ${userDetails.token}` },
        credentials: "include",
      }
    );

    if (!res.ok) throw new Error("Failed clients");

    const data = await res.json();

    // ✅ NORMALIZE like AddRecruitment
    const normalized = Array.isArray(data.body)
      ? data.body.map((c) => ({
          clientKey: c.clientKey,
          companyName: c.companyName || c.name || "",
        }))
      : [];

    setClients(normalized);
  } catch (e) {
    console.error("Client fetch failed", e);
    setClients([]);
  }
};


const fetchConfig = async (type, setter) => {
  try {
    const orgId = userDetails?.orgId || "6";
    const res = await fetch(
      `${config.API_BASE_URL}${config.VIEW_CLIENT_CONFIG_ENDPOINT}${orgId}?configType=${type}`,
      {
        headers: { Authorization: `Bearer ${userDetails.token}` },
        credentials: "include",
      }
    );
    if (!res.ok) throw new Error("Failed config");
    const data = await res.json();

    const list = Array.isArray(data)
      ? data
      : data?.data || data?.content || [];

    // 🔑 IMPORTANT
    if (type === "Band") {
      setter(
        list
          .filter((d) => d.isActive !== false)
          .map((d) => ({
            id: d.id,
            value: d.values || d.name || d.value,
          }))
      );
    } else if (type === "JobRole") {
      // keep id + value for job roles so we can send roleId
      setter(
        list
          .filter((d) => d.isActive !== false)
          .map((d) => ({ id: d.id, value: d.values || d.name || d.value }))
      );
    } else {
      setter(
        list
          .filter((d) => d.isActive !== false)
          .map((d) => d.values || d.name || d.value)
      );
    }
  } catch (e) {
    setter([]);
  }
};


  useEffect(() => {
  if (!showComponentCard) return;

  // modal open aagum pothu refresh data
  fetchClients();
  fetchConfig("JobRole", setJobRoles);
  fetchConfig("Band", setBands);


}, [showComponentCard]);
// const clientObj = clients.find(
//   (c) => String(c.clientKey) === String(clientId)
// );

// setSelectedClientId(clientId);
// setSelectedClientName(clientObj?.companyName || "");




console.log(bands);
const handleSaveSalaryConfig = async () => {
  try {

  if (!selectedClientId || !selectedJobRole || !selectedBand) {
  setErrorMsg("All required fields must be filled");
  return;
}



    // const selectedClientObj = clients.find(
    //   (c) => String(c.id) === String(selectedClient)
    // );
const payload = {
  orgKey: Number(userDetails.orgId),
  clientKey: Number(selectedClientId),
  clientName: selectedClientName,
  roleId: selectedJobRole ? Number(selectedJobRole) : null,
  jobRole: selectedJobRoleName || selectedJobRole,
  band: Number(selectedBand),
  clientPayment: Number(clientPayment),
  deduction: componentsList
    .filter((c) => c.componentType === "DEDUCTION")
    .reduce((sum, c) => sum + Number(c.componentValue || 0), 0),
  serviceCharges: Number(serviceCharge),
  components: componentsList.map((c) => ({
    componentName: c.componentName,
    componentType: c.componentType,
    calculationType: c.calculationType,
    componentValue: Number(c.componentValue),
    valuePeriod: c.valuePeriod,
    holidayCalendar: c.holidayCalendar,
  })),
};





        console.log("Client Id:", selectedClientId);
    console.log("Client Name:", selectedClientName);
    console.log("Payload:", payload);

    const res = await fetch(
      `${config.API_BASE_URL}${config.SALARY_CONFIG_ENDPOINT}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDetails.token}`,
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      throw new Error(data.message || `Server responded with ${res.status}`);
    }

    setSuccessMsg(data.message || "Salary configuration saved successfully!");
    setShowComponentCard(false);
    fetchSalaryConfigs();

  } catch (err) {
    console.error("Save error:", err);
    setErrorMsg(err.message || "Salary config save failed");
  }
};




  useEffect(() => {
    if (!userDetails?.orgId) return;
    fetchClients();
    fetchConfig("JobRole", setJobRoles);
    fetchConfig("Band", setBands);
  }, [userDetails.orgId]);

  // Fetch salary configs matching filters and populate table rows
  const fetchSalaryConfigs = async (params = {}) => {
    try {
      const client = params.client ?? filters.client;
      const jobRole = params.jobRole ?? filters.jobRole;
      const band = params.band ?? filters.band;

      const qp = new URLSearchParams();
      if (band) qp.append("band", band);
      if (client) qp.append("clientKey", client);
      if (jobRole) qp.append("roleId", jobRole);

      const url = `${config.API_BASE_URL}${config.SALARY_CONFIG_LIST_ENDPOINT}?${qp.toString()}`;
      const res = await fetch(url, {
        headers: { Authorization: `Bearer ${userDetails.token}` },
        credentials: "include",
      });
      if (!res.ok) throw new Error("Failed to fetch salary configs");
      const data = await res.json();

      const list = Array.isArray(data)
        ? data.body
        : data?.body || data?.data || data?.content || [];
console.log("Fetched salary configs:", list);
        const mapped = list.map((it, idx) => ({
          id: it.id ?? idx + 1,
          jobRole: it.jobRole || it.roleName || it.jobRoleName || it.role || "",
          band: it.band ?? it.bandId ?? it.bandValue ?? "",
          gross: it.grossSalary ?? it.gross ?? it.clientPayment ?? 0,
          deduction: it.deduction ?? it.deductionAmount ?? 0,
          net: it.netSalary ?? (Number(it.grossSalary ?? it.gross ?? it.clientPayment ?? 0) - Number(it.deduction ?? it.deductionAmount ?? 0)),
          service: it.serviceCharge ?? it.serviceCharges ?? it.service ?? 0,
        }));

      setRows(mapped);
    } catch (e) {
      console.error("Salary list fetch failed", e);
      setRows([]);
    }
  };

  const handleGo = () => {
    // keep filters state in sync (no-op if unchanged) and fetch
    setFilters({ ...filters });
    fetchSalaryConfigs();
  };

  const filteredRows = useMemo(() => {
    return rows.filter((r) => {
      if (filters.jobRole && r.jobRole !== filters.jobRole) return false;
      if (filters.band && String(r.band) !== String(filters.band)) return false;
      return true;
    });
  }, [rows, filters]);

  const startAdd = () => {
    setAdding(true);
    setEditingId(null);
  };

  const cancelAdd = () => setAdding(false);

  const saveAdd = (draft) => {
    const id = rows.length ? Math.max(...rows.map((r) => r.id)) + 1 : 1;
    setRows([...rows, { id, ...draft }]);
    setAdding(false);
  };

  const startEdit = (id) => setEditingId(id);
  const cancelEdit = () => setEditingId(null);
  const saveEdit = (id, draft) => {
    setRows(rows.map((r) => (r.id === id ? { ...r, ...draft } : r)));
    setEditingId(null);
  };
  const handleDeleteSalaryConfig = async (id) => {
    showConfirm("Are you sure you want to delete this salary config?", async () => {
      hideConfirm();
      try {
        const res = await fetch(
          `${config.API_BASE_URL}${config.SALARY_CONFIG_DELETE_ENDPOINT}/${id}`,
          {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${userDetails.token}`,
            },
            credentials: "include",
          }
        );
        if (!res.ok) {
          const errorData = await res.json().catch(() => ({}));
          throw new Error(errorData.message || `Server responded with ${res.status}`);
        }
        setSuccessMsg("Salary configuration deleted successfully!");
        fetchSalaryConfigs();
      } catch (err) {
        console.error("Delete failed:", err);
        setErrorMsg(`Delete failed: ${err.message}`);
      }
    });
  };

 const openEditModal = async (rowData) => {
  try {
    const res = await fetch(
      `${config.API_BASE_URL}${config.SALARY_CONFIG_VIEW_ENDPOINT}/${rowData.id}`,
      {
        headers: {
          Authorization: `Bearer ${userDetails.token}`,
        },
        credentials: "include",
      }
    );

    if (!res.ok) throw new Error("Failed to fetch salary config");

    const data = await res.json();
    const body = data.body || data;

    console.log("View API Data:", body);

    // 🔹 Basic Details
    setSelectedClientId(body.clientKey || "");
    setSelectedClientName(body.clientName || "");
    setSelectedJobRole(body.roleId || "");
    setSelectedJobRoleName(body.jobRole || "");
    setSelectedBand(body.band || "");
    setClientPayment(body.clientPayment || "");
    setServiceCharge(body.serviceCharges || "");

    // 🔹 Components
    if (Array.isArray(body.components)) {
      setComponentsList(
        body.components.map((c) => ({
          componentName: c.componentName || "",
          componentType: c.componentType || "EARNING",
          calculationType: c.calculationType === "CUSTOM" ? "PERCENTAGE" : (c.calculationType || "FIXED"),
          componentValue: c.componentValue || "",
          valuePeriod: c.valuePeriod || "MONTH",
          holidayCalendar: c.holidayCalendar || "INDIA",
        }))
      );
    }

    setEditingRowId(rowData.id);
    setShowComponentCard(true);

  } catch (err) {
    console.error("View API failed", err);
    setErrorMsg("Failed to load salary config details");
  }
};


  const closeModal = () => {
    setEditingRowId(null);
    setSelectedClientId("");
    setSelectedClientName("");
    setSelectedJobRole("");
    setSelectedJobRoleName("");
    setSelectedBand("");
    setClientPayment("");
    setServiceCharge("");
    setComponentsList([
      {
        componentName: "Basic Salary",
        componentType: "EARNING",
        calculationType: "FIXED",
        componentValue: "",
        valuePeriod: "MONTH",
        holidayCalendar: "INDIA",
      },
      {
        componentName: "PF",
        componentType: "DEDUCTION",
        calculationType: "PERCENTAGE",
        componentValue: "",
        valuePeriod: "MONTH",
        holidayCalendar: "INDIA",
      },
      {
        componentName: "ESI",
        componentType: "DEDUCTION",
        calculationType: "PERCENTAGE",
        componentValue: "",
        valuePeriod: "MONTH",
        holidayCalendar: "INDIA",
      },
    ]);
    setShowComponentCard(false);
  };

  const Net = (g, d) => (Number(g || 0) - Number(d || 0));

  const AddEditRow = ({ initial = {}, onSave, onCancel }) => {
    const [draft, setDraft] = useState({
      jobRole: initial.jobRole || "",
      band: initial.band ?? "",
      gross: initial.gross ?? "",
      deduction: initial.deduction ?? "",
      service: initial.service ?? "",
    });
    const net = Net(draft.gross, draft.deduction);
    return (
      <tr>
        <td>
          <select
            className='inline-select'
            value={draft.jobRole}
            onChange={(e) => setDraft({ ...draft, jobRole: e.target.value })}
          >
            <option value=''>Select Job Role</option>
            {jobRoles.map((jr) => (
              <option key={jr.id ?? jr} value={jr.id ?? jr}>
                {jr.value ?? jr}
              </option>
            ))}
          </select>
        </td>
        <td>
          <select
            className='inline-select'
            value={draft.band}
            onChange={(e) => setDraft({ ...draft, band: e.target.value })}
          >
            <option value=''>Band</option>
           {bands.map((b) => (
  <option key={b.id} value={b.id}>
    {b.value}
  </option>
))}

          </select>
        </td>
        <td className='right'>
          <input
            className='inline-input right'
            type='number'
            value={draft.gross}
            onChange={(e) => setDraft({ ...draft, gross: Number(e.target.value) })}
            placeholder='Gross'
          />
        </td>
        <td className='right'>
          <input
            className='inline-input right'
            type='number'
            value={draft.deduction}
            onChange={(e) => setDraft({ ...draft, deduction: Number(e.target.value) })}
            placeholder='Deduction'
          />
        </td>
        <td className='right'>{formatCurrency(net)}</td>
        <td className='right'>
          <input
            className='inline-input right'
            type='number'
            value={draft.service}
            onChange={(e) => setDraft({ ...draft, service: Number(e.target.value) })}
            placeholder='%'
          />
        </td>
        <td className='td-actions'>
          <button type='button' className='ok' onClick={() => onSave(draft)} title='Save'>
            <IoMdCheckmark size={18} />
          </button>
          <button type='button' className='danger' onClick={onCancel} title='Cancel'>
            <IoMdClose size={18} />
          </button>
        </td>
      </tr>
    );
  };

  return (
    <div className='salary-config'>
      {/* Popups */}
      {successMsg && <SuccessPopup message={successMsg} onClose={() => setSuccessMsg("")} />}
      {errorMsg && <ErrorPopup message={errorMsg} onClose={() => setErrorMsg("")} />}
      {confirmState.show && (
        <ConfirmPopup
          message={confirmState.message}
          onConfirm={confirmState.onConfirm}
          onCancel={hideConfirm}
        />
      )}
      <div className='salary-filters'>
        <div className='filter-field'>
          <label className='filter-label'>Client Name</label>
          <select
            value={filters.client}
            onChange={(e) => setFilters({ ...filters, client: e.target.value })}
          >
            <option value=''></option>
            {clients.map((c) => (
             <option key={c.clientKey} value={c.clientKey}>
  {c.companyName}
</option>

            ))}
          </select>
        </div>

        <div className='filter-field'>
          <label className='filter-label'>Job Role</label>
          <select
            value={filters.jobRole}
            onChange={(e) => setFilters({ ...filters, jobRole: e.target.value })}
          >
            <option value=''></option>
              {jobRoles.map((jr) => (
                <option key={jr.id ?? jr} value={jr.id ?? jr}>
                  {jr.value ?? jr}
                </option>
              ))}
          </select>
        </div>

        <div className='filter-field'>
          <label className='filter-label'>Band</label>
          <select
            value={filters.band}
            onChange={(e) => setFilters({ ...filters, band: e.target.value })}
          >
            <option value=''></option>
          {bands.map((b) => (
  <option key={b.id} value={b.id}>
    {b.value}
  </option>
))}

          </select>
        </div>

        <button type='button' className='go-btn' onClick={handleGo}>Go</button>
      </div>

      <div className='salary-header'>
        <h3>Salary Details</h3>
        <button
          type='button'
          className='header-add-btn'
          title='Add salary component'
          onClick={() => setShowComponentCard(true)}
        >
          <GrAddCircle size={18} />
        </button>
      </div>

      <table className='salary-table'>
        <thead>
          <tr>
            <th>Job Role</th>
            <th>Band</th>
            <th>Gross Salary</th>
            <th>Deduction</th>
            <th>Net salary</th>
            <th>Service Charges</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {adding && (
            <AddEditRow onSave={saveAdd} onCancel={cancelAdd} />
          )}

          {rows.map((r) => {
            const isEdit = editingId === r.id;
            if (isEdit) {
              return (
                <AddEditRow
                  key={`edit-${r.id}`}
                  initial={r}
                  onSave={(d) => saveEdit(r.id, d)}
                  onCancel={cancelEdit}
                />
              );
            }
            return (
              <tr key={r.id}>
                <td>{r.jobRole}</td>
                <td>{r.band}</td>
                <td className='right'>{formatCurrency(r.gross)}</td>
                <td className='right'>{formatCurrency(r.deduction)}</td>
                <td className='right'>{formatCurrency(r.net)}</td>
                <td className='right'>{r.service}%</td>
                <td className='td-actions'>
                 <button onClick={() => openEditModal(r)} title='Edit'>
  <CiEdit size={18} />
</button>

                  <button className='danger' onClick={() => handleDeleteSalaryConfig(r.id)} title='Delete'>
                    <RiDeleteBinLine size={18} />
                  </button>
                </td>
              </tr>
            );
          })}

          {!adding && rows.length === 0 && (
            <tr>
              <td colSpan={7} style={{ textAlign: 'center', padding: '20px' }}>No salary details found.</td>
            </tr> 
          )}
        </tbody>
      </table>

      {showComponentCard && (
        <div className='component-backdrop' onClick={closeModal}>
          <div className='component-card' onClick={(e) => e.stopPropagation()}>
            <div className='component-card-header'>
              <span>Component Structure</span>
              <button
                type='button'
                className='header-add-btn dark'
                title='Add Component'
                onClick={() => {
                  if (componentsList.length >= 5) {
                    setErrorMsg("Maximum of 5 components allowed.");
                    return;
                  }
                  setComponentsList([
                    ...componentsList,
                    {
                      componentName: "",
                      componentType: "EARNING",
                      calculationType: "FIXED",
                      componentValue: "",
                      valuePeriod: "MONTH",
                      holidayCalendar: "INDIA",
                    },
                  ]);
                }}
              >
                <GrAddCircle size={16} />
              </button>
            </div>
            <div className='component-card-body'>
              <div className="grid grid-3">
  <div className="form-field">
    <label>Client Name<span style={{ color: 'red' }}>*</span></label>
<select
  value={selectedClientId}
  onChange={(e) => {
    const clientKey = e.target.value;

    const clientObj = clients.find(
      (c) => String(c.clientKey) === String(clientKey)
    );

    setSelectedClientId(clientKey);
    setSelectedClientName(clientObj?.companyName || "");
  }}
>
  <option value=""></option>

  {clients.map((c) => (
    <option key={c.clientKey} value={c.clientKey}>
      {c.companyName}
    </option>
  ))}
</select>






  

  </div>

  <div className="form-field">
    <label>Job Role<span style={{ color: 'red' }}>*</span></label>
<select
  value={selectedJobRole}
  onChange={(e) => {
    const val = e.target.value;
    const jrObj = jobRoles.find((j) => String(j.id) === String(val)) || { value: val };
    setSelectedJobRole(val);
    setSelectedJobRoleName(jrObj.value || "");
  }}
>
  <option value=""></option>
  {jobRoles.map((jr) => (
    <option key={jr.id ?? jr} value={jr.id ?? jr}>
      {jr.value ?? jr}
    </option>
  ))}
</select>
  </div>

  <div className="form-field">
    <label>Band<span style={{ color: 'red' }}>*</span></label>
<select
  value={selectedBand}
  onChange={(e) => setSelectedBand(e.target.value)}
>
  <option value=""></option>
  {bands.map((b) => (
  <option key={b.id} value={b.id}>
    {b.value}
  </option>
))}

</select>

  </div>
</div>

<div className="grid grid-2">
  <div className="form-field">
    <label>Client Payment<span style={{ color: 'red' }}>*</span></label>
<input
  type="number"
  value={clientPayment}
  onChange={(e) => setClientPayment(e.target.value)}
/>
  </div>

  <div className="form-field">
    <label>Service Charge<span style={{ color: 'red' }}>*</span>(%)</label>
<input
  type="number"
  value={serviceCharge}
  onChange={(e) => setServiceCharge(e.target.value)}
/>
  </div>
</div>

              <div className='component-sections'>
                {componentsList.map((component, index) => (
  <div className="component-panel" key={index}>
    <div className="panel-title">Component-{index + 1}</div>

    <div className="panel-actions">
      <button
        className="trash"
        title="Remove"
        onClick={() =>
          setComponentsList(prev => prev.filter((_, i) => i !== index))
        }
      >
        <RiDeleteBinLine size={16} />
      </button>
    </div>

    <div className="grid grid-2">
      {/* Component Name */}
      <div className="form-field">
        <label>Component Name</label>
        <input
          type="text"
          value={component.componentName}
          onChange={(e) =>
            updateComponent(index, "componentName", e.target.value)
          }
        />
      </div>

      {/* Component Type */}
      <div className="form-field">
        <label>Component Type</label>
        <select
          value={component.componentType}
          onChange={(e) =>
            updateComponent(index, "componentType", e.target.value)
          }
        >
          <option value="EARNING">Earning</option>
          <option value="DEDUCTION">Deduction</option>
        </select>
      </div>

      {/* Calculation Type */}
      <div className="form-field">
        <label>Calculation Type</label>
        <select
          value={component.calculationType}
          onChange={(e) =>
            updateComponent(index, "calculationType", e.target.value)
          }
        >
          <option value="FIXED">Fixed</option>
          <option value="PERCENTAGE">Percentage</option>
        </select>
      </div>

      {/* Component Value */}
      <div className="form-field">
        <label>Component Value</label>
        <input
          type="number"
          value={component.componentValue}
          onChange={(e) =>
            updateComponent(index, "componentValue", e.target.value)
          }
        />
      </div>

      {/* Value Period */}
      <div className="form-field">
        <label>Value Period</label>
        <select
          value={component.valuePeriod}
          onChange={(e) =>
            updateComponent(index, "valuePeriod", e.target.value)
          }
        >
          <option value="MONTH">Monthly</option>
          <option value="DAY">Daily</option>
        </select>
      </div>

      {/* Holiday Calendar */}
      <div className="form-field">
        <label>Holiday Calendar</label>
        <select
          value={component.holidayCalendar}
          onChange={(e) =>
            updateComponent(index, "holidayCalendar", e.target.value)
          }
        >
          <option value="INDIA">INDIA</option>
        </select>
      </div>
    </div>
  </div>
))}

              </div>

            <div className='component-card-footer'>
  <button type='button' className='btn-cancel' onClick={closeModal}>
    Cancel
  </button>

  <button
    type='button'
    className='btn-save'
    onClick={editingRowId ? handleUpdateSalaryConfig : handleSaveSalaryConfig}
  >
    {editingRowId ? "Update Details" : "Save Details"}
  </button>
</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SalaryConfig;
